module.exports = __webpack_public_path__ + "media/images/synaptiq-logo-dark-a145ec1c.svg";